// import NineDotMenu from './NineDotMenu';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ThemeToggler from 'components/common/ThemeToggler';
// import NotificationDropdownMenu from './NotificationDropdownMenu';
// import { useState } from 'react';
// import DropdownSearchBox from 'components/common/DropdownSearchBox';
// import SearchResult from 'components/common/SearchResult';
// import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
/* eslint-disable @typescript-eslint/no-explicit-any */

import FeatherIcon from 'feather-icons-react';
import { Dropdown, Nav, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useState, useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

// import { Menu } from '@mui/material';
// import classNames from 'classnames';
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import ProfileDropdownMenu from './ProfileDropdownMenu';
import Avatar from 'components/base/Avatar';
import avatar from 'assets/img/icons/avatarImg.png';
// import GBFlag from 'assets/img/icons/great-britian-flag.svg';
// import UzbFlag from 'assets/img/icons/uzb-flag.svg';
// import RussianFlag from 'assets/img/icons/russian-flag.svg';
import Button from 'components/base/Button';
import { shiftIdActions } from 'store/shiftId/shiftId.slice';
// import anyDeskImg from 'assets/img/icons/anyDeskImg.png';
import { useWindowWidth } from 'utils/useWindowSize';

// import styles from './styles.module.scss';

import CreateCashBox from './CreateCashBox';
import legalEntityService from 'service/legalEntity';

// const languages = [
//   // {
//   //   icon: GBFlag,
//   //   title: 'English',
//   //   slug: 'en'
//   // },
//   {
//     icon: RussianFlag,
//     title: 'Русский',
//     slug: 'ru'
//   },
//   {
//     icon: UzbFlag,
//     title: "O'zbek",
//     slug: 'uz'
//   }
// ];

const NavItemsSlim = () => {
  const { t } = useTranslation();
  const windowSize: any = useWindowWidth();
  const { pathname } = useLocation();

  // const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  // const handleClick = (e: any) => {
  //   setAnchorEl(e.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const handleRowClick = (lang: any) => {
  //   i18n.changeLanguage(lang);
  //   handleClose();
  // };

  // const activeLang = useMemo(() => {
  //   return languages.find(lang => lang.slug === i18n.language);
  // }, [i18n.language]);

  // const open = Boolean(anchorEl);

  const shiftId = useSelector((state: any) => state?.shiftId?.shiftId);
  const userId = useSelector((state: any) => state?.auth?.user?.id);
  const dispatch = useDispatch();
  const socketRef = useRef<WebSocket | null>(null);
  const reconnectRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const connectWebSocket = useCallback(() => {
    if (!userId || socketRef.current) return;

    const socket = new WebSocket(
      `${process.env.REACT_APP_URL_WEBSOCET}/ws/${userId}`
    );
    socketRef.current = socket;

    socket.addEventListener('open', () => {
      console.log('WebSocket is connected.');
    });

    socket.addEventListener('message', event => {
      try {
        const jsonResponse = JSON.parse(event.data);
        console.log('jsonResponse', jsonResponse);

        if (jsonResponse.event === 'CASHBOX') {
          const { open, close, id, pid } = jsonResponse.data;
          console.log(
            `Cashbox event received: open=${open}, close=${close}, id=${id}`
          );

          if (open) {
            dispatch(shiftIdActions.setShiftId(id));
            dispatch(shiftIdActions.setShiftPid(pid));
            console.log('Cashbox is open.');
          }

          if (close) {
            dispatch(shiftIdActions.setShiftId(''));
            dispatch(shiftIdActions.setShiftPid(''));
            console.log('Cashbox is closed.');
          }
        } else {
          console.log('Unknown event:', jsonResponse.event);
        }
      } catch (error) {
        console.error('Error parsing JSON response:', error);
      }
    });

    socket.addEventListener('close', () => {
      console.log('WebSocket is closed. Reconnecting...');
      socketRef.current = null;
      reconnectRef.current = setTimeout(connectWebSocket, 1000); // Reconnect after 1 second
    });

    socket.addEventListener('error', error => {
      console.error('WebSocket error:', error);
    });
  }, [userId, dispatch]);

  // const openAnyDeskWithFallback = () => {
  //   const anyDeskURI = 'tg://';
  //   const fallbackURL = 'https://anydesk.com/en/downloads';

  //   const timeout = setTimeout(() => {
  //     if (!document.hasFocus()) {
  //       alert(
  //         'It seems AnyDesk is not installed. Redirecting to download page.'
  //       );
  //       window.open(fallbackURL, '_blank');
  //     }
  //   }, 1000);

  //   window.location.href = anyDeskURI;
  //   clearTimeout(timeout);
  // };

  const { data: paymentDateData } = useQuery(
    ['GET_PAYMENT_DATE', pathname],
    async () => {
      const res = await legalEntityService
        .getListPaymentDate({
          limit: 10,
          offset: 0
        })
        .then((res: any) => res?.next_payment_date || 1);

      return res;
    },
    {
      enabled: !!pathname
    }
  );

  const targetTime = paymentDateData ?? 1;
  const now = Date.now();

  const msInDay = 1000 * 60 * 60 * 24;
  const diffInDays = paymentDateData
    ? Math.floor((targetTime - now) / msInDay)
    : 1;

  let variant: 'success' | 'warning' | 'danger' = 'danger';
  if (diffInDays >= 30) {
    variant = 'success';
  } else if (diffInDays >= 15) {
    variant = 'warning';
  }

  useEffect(() => {
    connectWebSocket();

    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
      if (reconnectRef.current) {
        clearTimeout(reconnectRef.current);
      }
    };
  }, [connectWebSocket]);

  return (
    <div className="navbar-nav navbar-nav-icons flex-row">
      {/* <Nav.Item>
        <Nav.Link onClick={() => setOpenSearchModal(!openSearchModal)}>
          <FeatherIcon icon="search" size={12} />
        </Nav.Link>
      </Nav.Item> */}
      {/* <Nav.Item>
        <Dropdown autoClose="outside">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link py-0"
            variant=""
          >
            <FeatherIcon icon="bell" size={12} />
          </Dropdown.Toggle>
          <NotificationDropdownMenu />
        </Dropdown>
      </Nav.Item> */}
      {/* <Nav.Item>
        <Dropdown autoClose="outside">
          <Dropdown.Toggle
            as={Link}
            to="#!"
            className="dropdown-caret-none nav-link py-0"
            variant=""
          >
            <svg
              width="10"
              height="10"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="2" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="2" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="8" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="14" r="2" fill="currentColor"></circle>
              <circle cx="8" cy="2" r="2" fill="currentColor"></circle>
              <circle cx="14" cy="2" r="2" fill="currentColor"></circle>
            </svg>
          </Dropdown.Toggle>
          <NineDotMenu />
        </Dropdown>
      </Nav.Item> */}

      {windowSize > 768 && (
        <Nav.Item className="me-3">
          <OverlayTrigger
            placement="bottom"
            overlay={
              <Tooltip id="tooltip-disabled">
                {t('duration_of_program')}
              </Tooltip>
            }
          >
            <div
              onClick={e => {
                e.preventDefault();
              }}
              className="d-flex align-items-center"
              style={{ cursor: 'pointer', color: '#6E7891' }}
            >
              <FeatherIcon icon="clock" className="me-2" />
              <p
                className={`logo-text d-none d-sm-block mt-1`}
                /* prettier-ignore */
                style={{
                  color:
                    variant === 'danger'
                      ? '#dc3545'
                      : variant === 'warning'
                        ? '#ffc107'
                        : '#198754'
                }}
              >
                {diffInDays > 0 ? `${diffInDays}` : 1}
              </p>
            </div>
          </OverlayTrigger>
        </Nav.Item>
      )}

      {windowSize > 768 && (
        <Nav.Item className="me-3">
          <Button
            variant={shiftId === '' ? 'success' : 'danger'}
            onClick={() => setOpenModal(true)}
          >
            {shiftId === '' ? t('open_Shift') : t('close_shoft')}
          </Button>
        </Nav.Item>
      )}
      {/* <Nav.Item>
        <ThemeToggler slim />
      </Nav.Item> */}
      {/* <Nav.Item className="me-3">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="tooltip-disabled">AnyDesk</Tooltip>}
        >
          <div
            onClick={openAnyDeskWithFallback}
            className={classNames(`avatar avatar-l cursor-pointer`)}
          >
            <img src={anyDeskImg} alt="anyDesk" />
          </div>
        </OverlayTrigger>
      </Nav.Item> */}
      {/* <Nav.Item>
        <div className={styles.btn} onClick={handleClick}>
          <img style={{ width: '26px' }} src={activeLang?.icon} alt="" />
        </div>

        <Menu
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          classes={{ list: styles.menu, paper: styles.paper }}
        >
          {languages.map(language => (
            <div
              key={language.slug}
              className={styles.menuItem}
              onClick={() => handleRowClick(language.slug)}
            >
              <img style={{ width: '20px' }} src={language.icon} alt="" />
              <p className={styles.itemText}>{language.title}</p>
            </div>
          ))}
        </Menu>
      </Nav.Item> */}
      <Nav.Item>
        <Dropdown autoClose="outside">
          <Dropdown.Toggle
            as="div"
            className="dropdown-caret-none nav-link pe-0 py-0 cursor-pointer"
            variant=""
          >
            <Avatar src={avatar} size="xl" />
          </Dropdown.Toggle>
          <ProfileDropdownMenu />
        </Dropdown>
      </Nav.Item>

      <Modal
        show={openModal}
        onHide={() => {
          setOpenModal(false);
        }}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {shiftId === '' ? t('open_Shift') : t('close_shoft')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateCashBox setOpenModal={setOpenModal} />
        </Modal.Body>
      </Modal>

      {/* <Modal
        show={openSearchModal}
        onHide={() => setOpenSearchModal(false)}
        className="search-box-modal mt-15"
      >
        <Modal.Body className="p-0 bg-transparent">
          <DropdownSearchBox
            className="navbar-top-search-box"
            inputClassName="rounded-pill"
            size="lg"
            style={{ width: 'auto' }}
          >
            <SearchResult />
          </DropdownSearchBox>
        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default NavItemsSlim;
